import { Modal, Alert } from "../../common/utils/antd-imports/AntdImports";
import "./AlertMessageModal.css";

const AlertMessageModal = ({
  openAlertModal,
  messageText,
  descriptionText,
  onConfirm,
  onCancel,
  isClosable = false,
  okButtonText = "Ok",
}) => {
  return (
    <Modal
      className="alert-modal"
      open={openAlertModal}
      cancelButtonProps={{ style: { display: "none" } }}
      onOk={onConfirm}
      onCancel={onCancel}
      closable={isClosable}
      okText={okButtonText}
    >
      <Alert
        message={messageText}
        description={descriptionText}
        className="alert-style default-font"
      />
    </Modal>
  );
};

export default AlertMessageModal;
